import { TOKEN } from "@/config/http-json";
import bluetoothRepository from "@/bluetooth/BluetoothRepository";
import router from "@/router";
import store from "@/store";

import log from "@/util/log";

export const userStore = {
  namespaced: true,
  state: {
    userInfo: (() => {
      try {
        const omniUserJSON = window.localStorage.getItem("omni-user");
        const userData = JSON.parse(omniUserJSON);
        if (userData.id) {
          return userData;
        }
        window.localStorage.removeItem("omni-user", null);
        window.localStorage.removeItem(TOKEN, null);
      } catch (e) {
        return null;
      }
    })()
  },
  mutations: {
    setLoginInfo(state, payload) {
      if (payload) {
        state.userInfo = payload;
        window.localStorage.setItem("omni-user", JSON.stringify(payload));
      } else {
        state.userInfo = null;
        window.localStorage.removeItem(TOKEN, "");
      }

    }
  },
  getters: {
    isBrandUser(state) {
      const user = state.userInfo;
      return (user && user.supplierType === 0) || false;
    }
  },
  actions: {
    login() {

    },
    logout({ state, commit, rootState }, payload) {
      bluetoothRepository.disconnect();
      // window.localStorage.removeItem(TOKEN, "");
      window.localStorage.clear();
      commit("setLoginInfo", null);

      rootState.nfc.defaultCHomeData = null;
      rootState.nfc.defaultBHomeData = null;

      try {
        router.replace({ name: "Login", query: { hash: rootState.hash, ...payload } });
      } catch (e) {
        log(e);
      }
    },

    updateUser({state,commit,rootState},payload) {
      const userInfo = { ...state.userInfo, ...payload }
      commit('setLoginInfo', userInfo)
    }
  }

};